
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"dataProtection.title":"Datenschutz","dataConfidentialityLevel.label":"Geheimhaltungsgrad","dataProtectionLabel.label":"Kennzeichnungen"},"en":{"dataProtection.title":"Data protection","dataConfidentialityLevel.label":"Confidentiality level","dataProtectionLabel.label":"Data protection label"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();